// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-voicy__list__bottom[data-v-452df246]{margin-top:14px;padding-top:14px}.w-voicy__list__bottom button[data-v-452df246]{max-width:280px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
